import React, { useState } from 'react';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';

function TicketDetails({ ticket, onClose, onUpdate, onDelete }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTicket, setEditedTicket] = useState({
    status: ticket.status || 'new',
    priority: ticket.priority || 'mittel'
  });
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const formatDate = (timestamp) => {
    if (!timestamp || !timestamp.toDate) return 'N/A';
    return timestamp.toDate().toLocaleString('de-DE');
  };

  const handleChange = (e) => {
    setEditedTicket({
      ...editedTicket,
      [e.target.name]: e.target.value
    });
  };

  const deleteTicket = async () => {
    setIsDeleting(true);
    try {
      const ticketRef = doc(db, 'tickets', ticket.id);
      await deleteDoc(ticketRef);
      
      // Rufe onDelete auf, wenn vorhanden
      if (onDelete) {
        onDelete(ticket.id);
      }
      
      // Schließe das Modal nach erfolgreichem Löschen
      onClose();
    } catch (error) {
      console.error("Fehler beim Löschen des Tickets:", error);
      alert("Fehler beim Löschen des Tickets.");
    } finally {
      setIsDeleting(false);
      setShowDeleteConfirm(false);
    }
  };

  const saveChanges = async () => {
    setIsSaving(true);
    try {
      const ticketRef = doc(db, 'tickets', ticket.id);
      await updateDoc(ticketRef, {
        ...editedTicket,
        updatedAt: new Date()
      });
      
      // Wenn onUpdate Funktion bereitgestellt wurde, rufe sie auf
      if (onUpdate) {
        onUpdate({
          ...ticket,
          ...editedTicket,
          updatedAt: new Date()
        });
      }
      
      setIsEditing(false);
    } catch (error) {
      console.error("Fehler beim Aktualisieren des Tickets:", error);
      alert("Fehler beim Speichern der Änderungen.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{ 
        backgroundColor: 'white',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflow: 'auto',
        padding: '25px',
        boxShadow: '0 5px 20px rgba(0,0,0,0.2)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0 }}>Ticket Details</h2>
          <button 
            onClick={onClose}
            style={{ 
              border: 'none',
              background: '#f0eafb',
              color: '#5b21b6',
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ color: '#333', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
            {ticket.title}
          </h3>
          
          {isEditing ? (
            <div style={{ 
              display: 'flex', 
              flexWrap: 'wrap', 
              gap: '15px', 
              marginBottom: '15px',
              backgroundColor: '#f5f7fd',
              padding: '15px',
              borderRadius: '8px'
            }}>
              <div style={{ minWidth: '200px', flex: 1 }}>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '8px', 
                  fontWeight: '500',
                  color: '#374151' 
                }}>
                  Status:
                </label>
                <select
                  name="status"
                  value={editedTicket.status}
                  onChange={handleChange}
                  style={{ 
                    width: '100%', 
                    padding: '8px 12px',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    fontSize: '16px',
                    outline: 'none',
                    backgroundColor: 'white'
                  }}
                >
                  <option value="new">Neu</option>
                  <option value="in-progress">In Bearbeitung</option>
                  <option value="resolved">Erledigt</option>
                </select>
              </div>
              
              <div style={{ minWidth: '200px', flex: 1 }}>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '8px', 
                  fontWeight: '500',
                  color: '#374151' 
                }}>
                  Priorität:
                </label>
                <select
                  name="priority"
                  value={editedTicket.priority}
                  onChange={handleChange}
                  style={{ 
                    width: '100%', 
                    padding: '8px 12px',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    fontSize: '16px',
                    outline: 'none',
                    backgroundColor: 'white'
                  }}
                >
                  <option value="niedrig">Niedrig</option>
                  <option value="mittel">Mittel</option>
                  <option value="hoch">Hoch</option>
                </select>
              </div>
            </div>
          ) : (
            <div style={{ 
              display: 'flex', 
              gap: '10px', 
              marginBottom: '15px' 
            }}>
              <div style={{ 
                display: 'inline-block',
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: 
                  ticket.status === 'new' ? '#ffcdd2' : 
                  ticket.status === 'in-progress' ? '#fff9c4' : 
                  '#c8e6c9',
                fontSize: '14px'
              }}>
                {ticket.status === 'new' ? 'Neu' : 
                 ticket.status === 'in-progress' ? 'In Bearbeitung' : 
                 'Erledigt'}
              </div>
              
              <div style={{ 
                display: 'inline-block',
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: 
                  ticket.priority === 'hoch' ? '#ffcdd2' : 
                  ticket.priority === 'mittel' ? '#fff9c4' : 
                  '#c8e6c9',
                fontSize: '14px'
              }}>
                Priorität: {ticket.priority}
              </div>
            </div>
          )}
          
          <p style={{ 
            backgroundColor: '#f5f7fd', 
            padding: '15px', 
            borderRadius: '8px',
            whiteSpace: 'pre-wrap'
          }}>
            {ticket.description}
          </p>
        </div>

        {ticket.screenshotURL && (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ color: '#333', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
              Screenshot
            </h4>
            <div style={{ 
              padding: '10px', 
              border: '1px solid #e2e8f0', 
              borderRadius: '8px', 
              backgroundColor: '#f8fafc',
              textAlign: 'center' 
            }}>
              <img 
                src={ticket.screenshotURL} 
                alt="Screenshot" 
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '400px',
                  borderRadius: '4px'
                }} 
              />
            </div>
          </div>
        )}

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
          gap: '20px',
          backgroundColor: '#f5f7fd',
          padding: '15px',
          borderRadius: '8px'
        }}>
          <div>
            <h4 style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#666' }}>Benutzer</h4>
            <p style={{ margin: 0, fontWeight: 'bold' }}>{ticket.userEmail || 'N/A'}</p>
          </div>
          <div>
            <h4 style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#666' }}>App-Version</h4>
            <p style={{ margin: 0, fontWeight: 'bold' }}>{ticket.appVersion || 'N/A'}</p>
          </div>
          <div>
            <h4 style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#666' }}>Erstellt am</h4>
            <p style={{ margin: 0, fontWeight: 'bold' }}>{formatDate(ticket.createdAt)}</p>
          </div>
          <div>
            <h4 style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#666' }}>Zuletzt aktualisiert</h4>
            <p style={{ margin: 0, fontWeight: 'bold' }}>{formatDate(ticket.updatedAt)}</p>
          </div>
        </div>

        <div style={{ marginTop: '25px', textAlign: 'right', display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
          {/* Löschen-Button auf der linken Seite */}
          <div>
            {!isEditing && !showDeleteConfirm && (
              <button 
                onClick={() => setShowDeleteConfirm(true)}
                style={{ 
                  background: '#fee2e2',
                  color: '#b91c1c',
                  padding: '8px 15px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ marginRight: '5px' }}>🗑️</span>
                Löschen
              </button>
            )}
            
            {/* Bestätigungsdialog für das Löschen */}
            {showDeleteConfirm && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '14px', color: '#b91c1c' }}>Wirklich löschen?</span>
                <button 
                  onClick={deleteTicket}
                  style={{ 
                    background: '#dc2626',
                    color: 'white',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: isDeleting ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    opacity: isDeleting ? 0.7 : 1
                  }}
                  disabled={isDeleting}
                >
                  {isDeleting && (
                    <span style={{ 
                      display: 'inline-block',
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      border: '2px solid rgba(255,255,255,0.3)',
                      borderTopColor: 'white',
                      animation: 'spin 1s linear infinite',
                      marginRight: '8px'
                    }}></span>
                  )}
                  Ja
                </button>
                <button 
                  onClick={() => setShowDeleteConfirm(false)}
                  style={{ 
                    background: '#f1f5f9',
                    color: '#64748b',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                  disabled={isDeleting}
                >
                  Nein
                </button>
              </div>
            )}
          </div>
          
          {/* Rechte Seite: Bearbeiten/Speichern/Abbrechen/Schließen-Buttons */}
          <div style={{ display: 'flex', gap: '10px' }}>
            {isEditing ? (
              <>
                <button 
                  onClick={() => setIsEditing(false)}
                  style={{ 
                    background: '#f1f5f9',
                    color: '#64748b',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                  disabled={isSaving}
                >
                  Abbrechen
                </button>
                <button 
                  onClick={saveChanges}
                  style={{ 
                    background: '#5b21b6',
                    color: 'white',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: isSaving ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    opacity: isSaving ? 0.7 : 1
                  }}
                  disabled={isSaving}
                >
                  {isSaving && (
                    <span style={{ 
                      display: 'inline-block',
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      border: '2px solid rgba(255,255,255,0.3)',
                      borderTopColor: 'white',
                      animation: 'spin 1s linear infinite',
                      marginRight: '8px'
                    }}></span>
                  )}
                  Speichern
                </button>
              </>
            ) : (
              <>
                <button 
                  onClick={() => setIsEditing(true)}
                  style={{ 
                    background: '#5b21b6',
                    color: 'white',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                >
                  Bearbeiten
                </button>
                <button 
                  onClick={onClose}
                  style={{ 
                    background: '#f0eafb',
                    color: '#5b21b6',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                >
                  Schließen
                </button>
              </>
            )}
          </div>
        </div>

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
}

export default TicketDetails;